import { FormSkeleton } from '@globaleris/ui.library'
import { List, ListItem, Typography, makeStyles, useTheme } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { EnumPeriodoLiquidacion, EnumTipoCalculoConcepto } from '../../../../api'
import { EnumPeriodoCalculo } from '../../../../api/oData/enums/enumPeriodoCalculo'
import { EnumSubtiposFlexibilidad } from '../../../../api/oData/enums/enumSubtiposFlexibilidad'
import {
  enumEnumToValueString,
  enumKeyToValue,
  enumTranslateOption,
  toLocaleDate
} from '../../../../helpers'
import { FlexibilityDetails } from '../../flexibility.Model'
import { styles } from '../flexibilityEdit.styles'

type FlexibilityDetailsProps = {
  flexibility?: FlexibilityDetails
}

export const FlexibilityDetail: React.FC<FlexibilityDetailsProps> = ({ flexibility }) => {
  const [t] = useTranslation(['flexibilityDetails', 'globalerisLibrary', 'enums'])
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  return flexibility ? (
    <>
      <Typography variant="h1" color="primary" noWrap={true}>
        {flexibility?.description}
      </Typography>
      <List className={classes.resume}>
        <ListItem disableGutters>
          <Typography variant={'h2'}>
            {enumTranslateOption(
              flexibility?.calculationType,
              EnumTipoCalculoConcepto,
              'enums:EnumTipoCalculoConcepto'
            )}
          </Typography>
        </ListItem>
        <ListItem disableGutters>
          <Typography variant={'body2'}>
            {enumTranslateOption(
              enumKeyToValue(EnumSubtiposFlexibilidad, flexibility?.subtype),
              EnumSubtiposFlexibilidad,
              'enums:EnumSubtypeFlexibility'
            )}
          </Typography>
        </ListItem>
        <ListItem divider disableGutters>
          <Typography variant={'body2'}>{flexibility?.contractCode}</Typography>
        </ListItem>
        <ListItem divider disableGutters>
          <Typography variant={'caption'}>
            {t('flexibilityDetails:leftColumn.captions.flexibilityGroup')}
          </Typography>
          <Typography variant={'body2'}>{flexibility?.flexibilityGroup ?? '-'}</Typography>
        </ListItem>
        <ListItem divider disableGutters>
          <Typography variant={'caption'}>
            {t('flexibilityDetails:leftColumn.captions.period')}
          </Typography>
          <Typography variant={'body2'}>{flexibility?.period}</Typography>
        </ListItem>
        <ListItem divider disableGutters>
          <Typography variant={'caption'}>
            {t('flexibilityDetails:leftColumn.captions.signDate')}
          </Typography>
          <Typography variant={'body2'}>
            {flexibility?.signDate ? toLocaleDate(flexibility.signDate) : '-'}
          </Typography>
        </ListItem>
        <ListItem divider disableGutters>
          <Typography variant={'caption'}>
            {t('flexibilityDetails:leftColumn.captions.calculationPeriod')}
          </Typography>
          <Typography variant={'subtitle2'}>
            {enumEnumToValueString(EnumPeriodoCalculo, flexibility?.calculationPeriod)}
          </Typography>
        </ListItem>
        <ListItem divider disableGutters>
          <Typography variant={'caption'}>
            {t('flexibilityDetails:leftColumn.captions.settlementPeriod')}
          </Typography>
          <Typography variant={'subtitle2'}>
            {flexibility?.settlementPeriod
              ? enumEnumToValueString(EnumPeriodoLiquidacion, flexibility?.settlementPeriod)
              : ''}
          </Typography>
        </ListItem>
        {flexibility?.invoiceCycleDesc != null ? (
          <ListItem divider disableGutters>
            <Typography variant={'caption'}>
              {t('flexibilityDetails:leftColumn.captions.invoicingCycle')}
            </Typography>
            <Typography variant={'subtitle2'}>{flexibility?.invoiceCycleDesc}</Typography>
          </ListItem>
        ) : (
          <div></div>
        )}
        <ListItem divider disableGutters>
          <Typography variant={'caption'}>
            {t('flexibilityDetails:leftColumn.captions.comments')}
          </Typography>
          <Typography variant={'body2'}>{flexibility?.comments ?? '-'}</Typography>
        </ListItem>
      </List>
    </>
  ) : (
    <FormSkeleton withTitle={true} elevation={0} columns={1} inputs={9}></FormSkeleton>
  )
}
